<template>
  <detail-layout ref="layout" :tableCfg="tableCfg">
    <template slot="ExtraOptions" scope="props">
        <b-dropdown v-if="isReadOnly && dataValid && privUser" variant="default" size="sm">
          <template slot="button-content"> <i class="fa fa-cog"></i> </template>
          <!-- "id": 1 "Offer accepted"
          "id": 2 "Offer rejected"
          "id": 3 "Enrolled"
          "id": 4 "On a break"
          "id": 5 "Graduated"
          "id": 6 "Dropped out" -->
          <b-dropdown-item v-if="props.rec.contract_status_id === 2" @click="changeState(props.rec, 1)">Accept Offer</b-dropdown-item>
          <b-dropdown-item v-if="props.rec.contract_status_id === 1  || props.rec.contract_status_id === 3" @click="changeState(props.rec, 2)">Reject Offer</b-dropdown-item>
          <b-dropdown-item v-if="props.rec.contract_status_id === 1 || props.rec.contract_status_id === 2 || props.rec.contract_status_id === 4 || props.rec.contract_status_id === 6" @click="changeState(props.rec, 3)">Enrole</b-dropdown-item>
          <b-dropdown-item v-if="props.rec.contract_status_id === 3" @click="changeState(props.rec, 4)">Take a break</b-dropdown-item>
          <b-dropdown-item v-if="props.rec.contract_status_id === 3" @click="changeState(props.rec, 5)">Graduate</b-dropdown-item>
          <b-dropdown-item v-if="props.rec.contract_status_id > 2 && props.rec.contract_status_id < 6" @click="changeState(props.rec, 6)">Drop-out</b-dropdown-item>
           <b-dropdown-divider/>
           <b-dropdown-item @click="$refs.modalExportPaymentStatus.show()">Download PF Payment Status</b-dropdown-item>
           <b-dropdown-item v-if="false" @click="checkSwitchToSemesterPayment(props.rec)">Switch to semester payment</b-dropdown-item>
           <b-dropdown-item @click="requestPaymentInfo(props.rec)">Request payment info for refund</b-dropdown-item>
           <b-dropdown-item @click="downloadInvoiceDetails(props.rec)">Download Numbered Invoice Details</b-dropdown-item>
        </b-dropdown>
        <b-button v-if="props.rec.student_id" variant="default" size="sm" @click="$router.push({name: 'student', params: {id: props.rec.student_id}})">
          <i class="fa fa-arrow-right"></i> Student
        </b-button>
        <b-button variant="default" size="sm" @click="gotoOverviewWithFilter('planned_invoices', {contract_id: props.rec.id})">
          <i class="fa fa-arrow-right"></i> Planned Invoices
        </b-button>
        <b-button variant="default" size="sm" @click="gotoOverviewWithFilter('numbered_invoices', {contract_id: props.rec.id})">
          <i class="fa fa-arrow-right"></i> Numbered Invoices
        </b-button>
        <b-button  variant="default" size="sm" @click="gotoOverviewWithFilter('creditnote_invoices', {contract_id: props.rec.id})">
          <i class="fa fa-arrow-right"></i> Credit Notes
        </b-button>
        <b-button  variant="default" size="sm" @click="gotoOverviewWithFilter('invoicepayments', {contract_id: props.rec.id})">
          <i class="fa fa-arrow-right"></i> Invoice Payments
        </b-button>
        <b-button  variant="default" size="sm" @click="gotoOverviewWithFilter('planned_scholarshippayments', {contract_id: props.rec.id})">
          <i class="fa fa-arrow-right"></i> Planned Payments
        </b-button>
        <b-button  variant="default" size="sm" @click="gotoOverviewWithFilter('numbered_scholarshippayments', {contract_id: props.rec.id})">
          <i class="fa fa-arrow-right"></i> Numbered Payments
        </b-button>
    </template>
    <template slot="FormLayout" scope="props">
      <b-tabs small card ref="tabs" v-model="tabIndex">
        <b-tab title="General">
          <b-form ref="form" class="offset-md-0" autocomplete="off">
            <div v-if="dataValid" >
              <div class="row">
                <detail-field class="col-md-4" label="Student" field="student_id" :optionListApiUrl="'/students/choice/'" :rec="props.rec" :isReadOnly="!isNew" vvalidate="required" :validator="validator"/>
                <detail-field v-if="!isNew" class="col-md-4" label="Application Number" field="application_number" :rec="props.rec" :isReadOnly="true" vvalidate="ok" :validator="validator"/>
              </div>
              <div class="row">
                <detail-field class="col-md-4 field-right-border" label="Intake" field="intake" :optionListApiUrl="'/contracts_intake/choice/'" :rec="props.rec" :isReadOnly="isReadOnly" vvalidate="required" :validator="validator"/>
                <detail-field class="col-md-4 field-right-border" label="Round" field="application_round" :optionList="['0', '1', '2', '3', '4', '5']" :rec="props.rec" :isReadOnly="isReadOnly" vvalidate="required" :validator="validator"/>
                <detail-field class="col-md-4" label="Application ID" field="application_id" :rec="props.rec" :isReadOnly="isReadOnly" vvalidate="required" :validator="validator"/>
              </div>
              <div class="row">
                <detail-field class="col-md-4 field-right-border" label="Scholarship" field="scholarship_id" :optionListApiUrl="'/scholarships/choice/'" :rec="props.rec" :isReadOnly="isReadOnly" vvalidate="required" :validator="validator"/>
                <detail-field class="col-md-4 field-right-border" label="Status" field="contract_status_id" :optionListApiUrl="'/contract_status/choice/'" :rec="props.rec" :isReadOnly="true" vvalidate="ok" :validator="validator"/>
                <detail-field class="col-md-4" label="Status Date" field="contract_status_date" :rec="props.rec" :isReadOnly="isReadOnly" type="date" vvalidate="ok" :validator="validator"/>
              </div>
              <div class="row">
                <detail-field class="col-md-4 field-right-border" label="Program" field="program_id" :optionListApiUrl="'/programs/choice/'" :rec="props.rec" :isReadOnly="isReadOnly" vvalidate="required" :validator="validator"/>
                <detail-field class="col-md-4 field-right-border" label="DA Application ID" field="da_application_id" :rec="props.rec" :isReadOnly="isReadOnly" vvalidate="ok" :validator="validator"/>
                <detail-field class="col-md-4 field-right-border" label="DA Offer Status" field="da_offer_type" :rec="props.rec" :isReadOnly="isReadOnly" vvalidate="ok" :validator="validator"/>
              </div>
              <div class="row">
                <detail-field class="col-md-4 field-right-border" label="University Y1" field="y1_university_id" :optionListApiUrl="'/universities/choice/'" :rec="props.rec" :isReadOnly="isReadOnly" vvalidate="required" :validator="validator"/>
                <detail-field class="col-md-4 field-right-border" label="Y1 Finished" field="year1_finished" :rec="props.rec" :isReadOnly="isReadOnly" type="boolean" vvalidate="ok" :validator="validator"/>
                <detail-field class="col-md-4" label="Active" field="active" :rec="props.rec" :isReadOnly="isReadOnly" type="boolean" vvalidate="ok" :validator="validator"/>
              </div>
              <div class="row">
                <detail-field class="col-md-4 field-right-border" label="University Y2" field="y2_university_id" :optionListApiUrl="'/universities/choice/'" :rec="props.rec" :isReadOnly="isReadOnly" vvalidate="ok" :validator="validator"/>
                <detail-field class="col-md-4 field-right-border" label="Y2 Finished" field="year2_finished" :rec="props.rec" :isReadOnly="isReadOnly" type="boolean" vvalidate="ok" :validator="validator"/>
              </div>
              <div class="row">
              </div>
              <div class="row">
                <detail-field class="col-md-4 field-right-border" label="Start Date" field="start_date" @input="onStartDateInput(props.rec, $event)" :rec="props.rec" :isReadOnly="isReadOnly" type="date" vvalidate="required" :validator="validator"/>
                <detail-field class="col-md-4 field-right-border" ref="enddate" label="End Date" field="end_date" :rec="props.rec" :isReadOnly="isReadOnly" type="date" vvalidate="required" :validator="validator"/>
                <detail-field class="col-md-4" label="Expected Graduation Date" field="expected_graduation_date" :rec="props.rec" :isReadOnly="isReadOnly" type="date" vvalidate="ok" :validator="validator"/>
              </div>
              <div class="row">
              <detail-field v-if="!isNew" class="col-md-4" label="Bank Info Required" field="bankinfo_required" :rec="props.rec" :isReadOnly="isReadOnly" type="boolean" vvalidate="required" :validator="validator"/>
              <detail-field class="col-md-4" label="Check University Fee Payment" field="check_universityfee_payment" :rec="props.rec" :isReadOnly="isReadOnly" type="boolean" vvalidate="required" :validator="validator"/>
              <detail-field class="col-md-4" label="Instalments" field="instalments" :rec="props.rec" :isReadOnly="isReadOnly" type="boolean" vvalidate="required" :validator="validator"/>
              </div>
              <div class="row">
                <detail-field class="col-md-4" label="Contract Sent" field="contract_sent_date" :rec="props.rec" :isReadOnly="isReadOnly" type="date" vvalidate="ok" :validator="validator"/>
                <detail-field class="col-md-4" label="Contract Signed" field="contract_signed_date" :rec="props.rec" :isReadOnly="isReadOnly" type="date" vvalidate="ok" :validator="validator"/>
              </div>
              <div class="row">
                <detail-field class="col-md-4" label="Comments" field="comments" type="textarea" :rec="props.rec" :isReadOnly="isReadOnly" vvalidate="ok" :validator="validator"/>
              </div>
              <div class="row" v-if="!isNew">
                <detail-field class="col-md-6" label="Created" field="creation_timestamp" field2="creation_user" :static="true" :rec="props.rec" :isReadOnly="true" type="timestamp_user" vvalidate="ok" :validator="validator"/>
                <detail-field class="col-md-6" label="Last Edit" field="edit_timestamp" field2="edit_user" :static="true" :rec="props.rec" :isReadOnly="true" type="timestamp_user" vvalidate="ok" :validator="validator"/>
              </div>
              <div class="row" v-if="!isNew">
                <detail-field class="col-md-6" label="Invoiced Amount" field="invoiced_amount" :rec="props.rec" :isReadOnly="true" type="money" vvalidate="ok" :validator="validator"/>
                <detail-field class="col-md-6" label="Paid Amount" field="payed_amount" :rec="props.rec" :isReadOnly="true" type="money" vvalidate="ok" :validator="validator"/>
                <detail-field class="col-md-6" label="To Be Paid Amount" field="to_be_payed_amount" :rec="props.rec" :isReadOnly="true" type="money" vvalidate="ok" :validator="validator"/>
                <detail-field class="col-md-6" label="Planned Amount" field="planned_amount" :rec="props.rec" :isReadOnly="true" type="money" vvalidate="ok" :validator="validator"/>
              </div>
            </div>
          </b-form>
        </b-tab>
        <b-tab :title="'Documents (' + ((dataValid && props.rec.files)  ? props.rec.files.length : 0) + ')'">
            <div v-if="dataValid && props.rec.files">
              <b-card v-for="(doc, index) in props.rec.files" class="template-card" :key="doc.id">
                  {{doc.filename}}<br/>
                  {{doc.description}}<br/>
                  <b-button @click="downloadDocument(doc)"><i class="fa fa-download"></i> Download</b-button>
                  <b-button  v-if="privUser" @click="activeDocument = doc" v-b-modal.modalDocDeleteOk><i class="fa fa-trash"></i> Delete</b-button>
              </b-card>
            </div>
            <b-card v-if="privUser">
              <b-form-file ref="fileinput" v-model="documentToUpload" placeholder=" "></b-form-file>
              <detail-field label="File Type" field="ft_id" :optionListApiUrl="'/file_types/choice/'" :rec="fileRec" :isReadOnly="false" vvalidate="ok" :validator="validator"/>
              <detail-field label="Description" field="description" :rec="fileRec" :isReadOnly="false" vvalidate="ok" :validator="validator"/>
              <b-button @click="uploadDocument(props.rec.id, documentToUpload)" :disabled="!documentToUpload"><i class="fa fa-upload"></i> Upload</b-button>
            </b-card>
        </b-tab>
      </b-tabs>
      <b-modal id="modalDocDeleteOk" title="Delete Document" ok-title="Yes" close-title="No" @ok="deleteDocument" >
        Are you sure you want to delete this document?
      </b-modal>
      <b-modal ref="modalSwitchSemesterPaymentOk" title="Switch to Semester Payment" ok-title="Yes" close-title="No" @ok="doSwitchToSemesterPayment" >
        Are you sure to switch to semester payment?
      </b-modal>
      <b-modal ref="modalExportPaymentStatus" size="lg" title="Download PF Payment Status" ok-title="Download" close-title="Cancel" @ok="downloadPaymentStatus(props.rec)" :ok-disabled="false">
        <b-form ref="form" class="offset-md-1" autocomplete="off">
            <detail-field class="col-md-6" label="Simulation date for testing" type="date" field="simulation_date" :rec="downloadPaymentRec" vvalidate="ok" :validator="validator"/>
        </b-form>
      </b-modal>
    </template>
  </detail-layout>
</template>

<script>
import DetailMixin from '../../components/DetailMixin'
import FieldDefs from './FieldDefs.js'
import api from '../../api'

export default {
  name: 'contract_detail',
  mixins: [DetailMixin],
  data () {
    return {
      tableCfg: FieldDefs,
      tabIndex: 0,
      fileRec: {ft_id: 1, description: ''},
      documentToUpload: '',
      activeDocument: null,
      activeRec: null,
      downloadPaymentRec: {}
    }
  },
  methods: {
    downloadPaymentStatus (rec) {
      console.log(rec)
      if (this.downloadPaymentRec) {
        this.api.downloadPost('/contracts/' + rec.id + '/download_pf_paymentstatus', this.downloadPaymentRec, 'Participation_Fee_Status.pdf')
      }
    },
    changeState (rec, contractStatusId) {
      api.putUpdate('/contracts/' + rec.id + '/update_status', {contract_status_id: contractStatusId}, data => {
        Object.assign(rec, data)
      }, 'updating state', this.$refs.layout.$refs.alert)
    },
    downloadDocument (doc) {
      api.downloadPost('/contract_files/' + doc.id + '/download', {}, doc.filename)
    },
    uploadDocument (contractId, documentToUpload) {
      let rec = {contract_id: contractId, ft_id: this.fileRec.ft_id, description: this.fileRec.description, filename: documentToUpload.name}
      api.post('/contract_files/', rec,
      cfData => {
        console.log('post result ', cfData)
        api.uploadPost('/contract_files/' + cfData.id + '/upload', [documentToUpload], () => {
          this.$refs.fileinput.setFiles(null)
          this.fileRec.description = ''
          this.$refs.layout.getRecord()
        }, 'uploading document', this.$refs.layout.$refs.alert)
      },
      'uploading document', this.$refs.layout.$refs.alert)
    },
    deleteDocument () {
      api.delete('/contract_files/' + this.activeDocument.id,
      data => { this.$refs.layout.getRecord() },
      'deleting document', this.$refs.layout.$refs.alert)
    },
    checkSwitchToSemesterPayment (rec) {
      this.activeRec = rec
      this.$refs.modalSwitchSemesterPaymentOk.show()
    },
    doSwitchToSemesterPayment () {
      // console.log('doSwitchToSemesterPayment', this.activeRec)
      api.post('/contracts/' + this.activeRec.id + '/switch_to_semester_payment', {},
      data => {
        // console.log('doSwitchToSemesterPaymentResult', data)
        // this.rec = data
        this.$refs.layout.$refs.alert.appendMessage(data.message + '<br/>')
      },
      'switch to semester payment', this.$refs.layout.$refs.alert)
    },
    requestPaymentInfo (rec) {
      api.post('/contracts/' + rec.id + '/send_email_paymentinfo', {},
      data => {
        // console.log(data)
        // this.rec = data
      },
      'requesting payment info', this.$refs.layout.$refs.alert)
    },
    downloadInvoiceDetails (rec) {
      api.downloadPost('/contracts/' + rec.id + '/download_invoice_details', {},
      data => {
        // console.log(data)
        // this.rec = data
      },
      'downloading invoice details', this.$refs.layout.$refs.alert)
    },
    onStartDateInput (rec, startDate) {
      rec.end_date = new Date(startDate.getFullYear() + 2, startDate.getMonth(), startDate.getDate())
      rec.end_date = new Date(rec.end_date - 1)
    }
  }
}
</script>



// WEBPACK FOOTER //
// Detail.vue?9635f6a8